import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ProductLikeComponent } from '../../app/content/layout/components/product/product-like/product-like.component';
import { withCommonDecorators } from '../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../_mocks';
import { signal } from '@angular/core';
import { CustomerReviewsAndWishlistService } from '../../app/core/services/customer-reviews-and-wishlist.service';

function withWishlist(items: any[] = []) {
  return {
    provide: CustomerReviewsAndWishlistService,
    useValue: {
      wishlist: signal(items),
      adjustWishlist: () => {},
    },
  };
}

const meta: Meta<ProductLikeComponent> = {
  title: 'Atoms/Product Like',
  component: ProductLikeComponent,
  parameters: {
    layout: 'centered',
    docs: {
      description: {
        component: 'Heart icon for adding/removing products from the wishlist.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<ProductLikeComponent>;

const product = createDamilanoBarberaProduct();

export const Default: Story = {
  decorators: [...withCommonDecorators([withWishlist()])],
  args: {
    product: product as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.user-like')).toBeTruthy();
  },
};

export const InWishlist: Story = {
  decorators: [...withCommonDecorators([withWishlist([product])])],
  args: {
    product: product as any,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.user-like')).toBeTruthy();
  },
};

export const AsButton: Story = {
  decorators: [...withCommonDecorators([withWishlist()])],
  args: {
    product: product as any,
    useAsButton: true,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.user-like')).toBeTruthy();
  },
};

export const NullProduct: Story = {
  decorators: [...withCommonDecorators([withWishlist()])],
  args: {
    product: null,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-like')).toBeTruthy();
  },
};
